import { Injectable, inject } from '@angular/core'
import { select, Store, Action } from '@ngrx/store'
import * as ProjectorsSelectors from './projectors.selectors'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

@Injectable({ providedIn: 'root' })
export class ProjectorsFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(ProjectorsSelectors.selectProjectorLoaded))
  allProjectors$ = this.store.pipe(select(ProjectorsSelectors.selectAllProjector))
  selectedProjectors$ = this.store.pipe(select(ProjectorsSelectors.selectEntity))
  templatesLoaded$ = this.store.pipe(select(ProjectorsSelectors.selectTemplatesLoaded))
  allProjectorTemplates$ = this.store.pipe(select(ProjectorsSelectors.selectAllProjectorTemplates))
  presenterEditToken$ = this.store.pipe(select(ProjectorsSelectors.selectPresenterEditToken))
  editCreateLoaded$ = this.store.pipe(select(ProjectorsSelectors.selectEditCreateLoaded))
  selectedProjectorId$ = this.store.pipe(select(ProjectorsSelectors.selectSelectedId))

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
